export enum CartDetailTypeEnum {
  RULE = "rule",
  EVENT = "event",
  COACH_PLAN = "coach_plan",
}
